var map = {
	"./bi/bg-work.png": "3e2a",
	"./bi/bg.png": "e9c6",
	"./bi/bottom-bg.png": "689a",
	"./bi/center-default-bg.png": "4bdc",
	"./bi/center-default-title.png": "98b9",
	"./bi/default-img.png": "d4e2",
	"./bi/entry-button.png": "da7e",
	"./bi/entry-logo.png": "0376",
	"./bi/gd.png": "1ebb",
	"./bi/gj.png": "fcd5",
	"./bi/header.png": "803d",
	"./bi/icon-1.png": "57f2",
	"./bi/icon-2.png": "d00d",
	"./bi/icon-3.png": "78b2",
	"./bi/icon-4.png": "7a38",
	"./bi/icon-button.png": "97a9",
	"./bi/icon-company.png": "8059",
	"./bi/icon-title-1.png": "1d4d",
	"./bi/icon-title-2.png": "5ca2",
	"./bi/icon-title-3.png": "2e93",
	"./bi/icon-title-4.png": "a4e9",
	"./bi/icon-triangle.png": "2b14",
	"./bi/img-border.png": "ba4e",
	"./bi/item-bg.png": "e145",
	"./bi/line-1.png": "6956",
	"./bi/line-2.png": "40c0",
	"./bi/line-3.png": "cd1b",
	"./bi/line-4.png": "14fe",
	"./bi/loading.gif": "811a",
	"./bi/logo.png": "5697",
	"./bi/map-symble.png": "c4ba",
	"./bi/title-bg-long.png": "6cdc",
	"./bi/title-bg.png": "197e",
	"./bi/top-1.png": "164e",
	"./bi/top-2.png": "29e5",
	"./bi/top-3.png": "e58f",
	"./bi/wx-box.png": "7bd5",
	"./bi/wx-default.png": "34f5",
	"./bi/wx.png": "c8f7",
	"./big-data/center-details-data1.png": "baf0",
	"./big-data/center-details-data2.png": "a59e",
	"./big-data/center-details-data3.png": "cf91",
	"./big-data/center-details-data4.png": "57ae",
	"./big-data/center-details-data5.png": "7722",
	"./big-data/center-details-data6.png": "d97e",
	"./guang.png": "5190",
	"./headers/juxing1.png": "a8f4",
	"./headers/juxing2.png": "eba7",
	"./headers/setting.png": "006b",
	"./left_top_hong.png": "6722",
	"./left_top_huang.png": "d3b3",
	"./left_top_lan.png": "6d50",
	"./left_top_lv.png": "60d1",
	"./long-insure-dispatch/bg-1.png": "a1d4",
	"./long-insure-dispatch/bg-2.png": "6bb3",
	"./long-insure-dispatch/bg.png": "cc4c",
	"./long-insure-dispatch/icon-hint.png": "eabc",
	"./long-insure-dispatch/icon-title.png": "c436",
	"./long-insure-dispatch/uploadvideo.png": "43bf",
	"./long-insure-dispatch/图标.png": "9cfd",
	"./long-insure-dispatch/拖动排序.png": "fb0f",
	"./pageBg.png": "b5d6",
	"./titles/you.png": "4126",
	"./titles/zuo.png": "2e91",
	"./top.png": "90c5",
	"./video/icon-delete-hover.png": "c612",
	"./video/icon-delete.png": "5a6c",
	"./video/icon-download-hover.png": "9127",
	"./video/icon-download.png": "bb4c",
	"./video/icon-play-hover.png": "b8b5",
	"./video/icon-play.png": "0d11",
	"./xieyou.png": "9ae6",
	"./xiezuo.png": "82f8",
	"./zuo_xuxian.png": "46c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";